import { atom } from "recoil";

const loginStateAtom = atom({

    key:"loginState",
    default: window.localStorage.getItem('fm_token') ? true : false

});

export default loginStateAtom;